import { RepartitionChartItem } from 'src/app/shared/model/cybersocxdr/charts/common';

export const repartitionChartItemToHighchartsSeries = (item: RepartitionChartItem) => {
  return {
    name: item.name,
    y: item.volume,
    drilldown: item?.detail ? item.name : null,
  };
};
